"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    poi: {
        en: "Points Of Interest",
        es: "Puntos de Interés",
    },
    selectVisits: {
        en: "Visits",
        es: "Visitas",
    },
    selectNoVisits: {
        en: "No Visit",
        es: "No Visitados",
    },
    selectOffVisits: {
        en: "Off Visit",
        es: "Visita Extra",
    },
    poiNotVisited: {
        en: "Points Of Interest not Visited",
        es: "Puntos de Interés no visitados",
    },
    visits: {
        en: "Resume visits",
        es: "Resumen de visitas",
    },
    device: {
        en: "Unit",
        es: "Unidad",
    },
    local: {
        en: "Local",
        es: "Local",
    },
    utc: {
        en: "UTC",
        es: "UTC",
    },
    initial: {
        en: "Initial",
        es: "Inicial",
    },
    final: {
        en: "Final",
        es: "Final",
    },
    hour: {
        en: "Hour",
        es: "Hora",
    },
    bytime: {
        en: "Time",
        es: "Tiempo",
    },
    dateRange: {
        en: "Date range",
        es: "Rango de fechas",
    },
    speedRange: {
        en: "Speed range",
        es: "Rango de velocidad",
    },
    parking: {
        en: "Parking",
        es: "Estacionado",
    },
    parkingTime: {
        en: "Parking time",
        es: "Tiempo estacionado",
    },
    parkingCount: {
        en: "Parking count",
        es: "Total paradas",
    },
    generateReport: {
        en: "Generate report",
        es: "Generar reporte",
    },
    date: {
        en: "Date",
        es: "Fecha",
    },
    movement: {
        en: "Movement",
        es: "Movimiento",
    },
    distance: {
        en: "Distance",
        es: "Distancia",
    },
    max: {
        en: "Maximum",
        es: "Maxima",
    },
    min: {
        en: "Minimum",
        es: "Minima",
    },
    avg: {
        en: "Average",
        es: "Promedio",
    },
    coordinates: {
        en: "Coordinates",
        es: "Coordenadas",
    },
    percentage: {
        en: "Percentage",
        es: "Porcentaje",
    },
    latitude: {
        en: "Latitude",
        es: "Latitud",
    },
    longitude: {
        en: "Longitude",
        es: "Longitud",
    },
    altitude: {
        en: "Altitude",
        es: "Altitud",
    },
    duration: {
        en: "Duration",
        es: "Duración",
    },
    battery: {
        en: "Battery %",
        es: "% Batería",
    },
    batteryPercentage: {
        en: "Battery percentage",
        es: "Porcentaje de batería",
    },
    interval: {
        en: "Interval",
        es: "Intervalo",
    },
    export: {
        en: "Export",
        es: "Exportar",
    },
    exportToExcel: {
        en: "Export to Excel",
        es: "Exportar a Excel",
    },
    optionsParkingTime: {
        en: "Parking time",
        es: "Tiempo estacionado",
    },
    loading: {
        en: "Loading...",
        es: "Cargando...",
    },
    noData: {
        en: "No rows found",
        es: "No hay registros",
    },
    noLinks: {
        en: "No links found",
        es: "No hay links",
    },
    status: {
        en: "Status",
        es: "Estado",
    },
    isIdle: {
        en: "Idle",
        es: "Tiempo en Ocio",
    },
    isOn: {
        en: "Moving",
        es: "En Movimiento",
    },
    isOff: {
        en: "Stopped",
        es: "Estacionado",
    },
    selectDevices: {
        en: "Please select a device",
        es: "Por favor seleccione una unidad",
    },
    selectClients: {
        en: "Please select a client",
        es: "Por favor seleccione un cliente",
    },
    selectRangeDate: {
        en: "Please select a range date",
        es: "Por favor seleccione un rango de fechas",
    },
    today: {
        en: "Today",
        es: "Hoy",
    },
    thisWeek: {
        en: "This Week",
        es: "Semana actual",
    },
    lastWeek: {
        en: "Last Week",
        es: "Semana anterior",
    },
    lastMonth: {
        en: "Last Month",
        es: "Mes anterior",
    },
    thisMonth: {
        en: "This Month",
        es: "Mes actual",
    },
    drivingReport: {
        en: "Driving",
        es: "Manejo",
    },
    currentStateReport: {
        en: "Current state",
        es: "Estado actual",
    },
    currentStateTitle: {
        en: "Current state report",
        es: "Reporte de estado actual",
    },
    idleTitle: {
        en: "Idle report",
        es: "Reporte de Estacionado con Motor Encendido",
    },
    parkingReport: {
        en: "Parking",
        es: "Estacionado",
    },
    speedingReport: {
        en: "Speeding",
        es: "Exceso de velocidad",
    },
    positionLogReport: {
        en: "Unit log",
        es: "Historial de unidad",
    },
    maintenanceLogReport: {
        en: "Maintenances",
        es: "Mantenimiento",
    },
    gasConsumptionReport: {
        en: "Fuel",
        es: "Combustible",
    },
    gasConsumptionTitle: {
        en: "Fuel Report",
        es: "Reporte de Combustible",
    },
    fuel: {
        en: "Fuel",
        es: "Combustible",
    },
    pointOfInterestReport: {
        en: "Visits",
        es: "Visitas",
    },
    pointOfInterestUnvisited: {
        en: "Unvisited",
        es: "No Visitados",
    },
    pointOfInterestOffVisits: {
        en: "Off Visits",
        es: "Visita Extra",
    },
    commandHistoryReport: {
        en: "Sent Commands",
        es: "Comandos enviados",
    },
    loginHistoryReport: {
        en: "Login history",
        es: "Historial de Acceso",
    },
    unitsPerClientReport: {
        en: "Units per client",
        es: "Unidades por cliente",
    },
    geofencesReport: {
        en: "Geofences",
        es: "Geocercas",
    },
    photosReport: {
        en: "Photos",
        es: "Fotos",
    },
    temperatureReport: {
        en: "Temperature",
        es: "Temperatura",
    },
    maintenanceCurrentStateReport: {
        en: "Maintenance Current State",
        es: "Estado actual de mantenimientos",
    },
    table: {
        en: "Table",
        es: "Tabla",
    },
    chart: {
        en: "Chart",
        es: "Gráfico",
    },
    allSpeeds: {
        en: "Show all speeds ",
        es: "Mostrar todas las velocidades ",
    },
    drivingTitle: {
        en: "Driving report",
        es: "Reporte de manejo",
    },
    parkingTitle: {
        en: "Parking report",
        es: "Reporte de estacionado",
    },
    speedingTitle: {
        en: "Speeding report",
        es: "Reporte de velocidad",
    },
    positionLogTitle: {
        en: "Position log report",
        es: "Reporte de posición",
    },
    maintenanceLogTitle: {
        en: "Maintenance log report",
        es: "Reporte de mantenimientos",
    },
    eventsReport: {
        en: "Events",
        es: "Eventos",
    },
    eventsTitle: {
        en: "Events report",
        es: "Reporte de eventos",
    },
    speedEvents: {
        en: "The unit moved at {speed} when limit was {speedLimit}.",
        es: "La unidad se movió a {speed} cuando el limite era {speedLimit}.",
    },
    autorizedScheduleEventNoRange: {
        en: "The unit moved out of schedule.",
        es: "La unidad se movió fuera del horario autorizado.",
    },
    autorizedScheduleEvent: {
        en: "The unit moved out of schedule, authorize schedule is from:{from}  to:{to}.",
        es: "La unidad se movió fuera del horario, el horario autorizado es desde:{from} hasta:{to}.",
    },
    eventInformation: {
        en: "Event information",
        es: "Información de evento",
    },
    positionEditorTitle: {
        en: "Unit log report",
        es: "Reporte de registro de unidades",
    },
    commandHistoryTitle: {
        en: "Command history report",
        es: "Reporte de historial de comandos",
    },
    loginHistoryTitle: {
        en: "Login history report",
        es: "Reporte de Historial de Acceso",
    },
    unitsPerClientTitle: {
        en: "Units per client report",
        es: "Reporte de unidades por cliente",
    },
    geofencesTitle: {
        en: "Geofences report",
        es: "Reporte de geocerca",
    },
    photosTitle: {
        en: "Photos per unit report",
        es: "Reporte de fotos por unidad",
    },
    temperaruteTitle: {
        en: "Temperature report",
        es: "Reporte de temperatura",
    },
    poiTitle: {
        en: "Points of Interest Report",
        es: "Reporte de Puntos de Interés",
    },
    distanceTitle: {
        en: "Distance report",
        es: "Reporte de Distancia",
    },
    bingSpeedTitle: {
        en: "Posted speed limit Report",
        es: "Reporte de limite de velocidad",
    },
    bingSpeed: {
        en: "Posted speed limit",
        es: "limite de velocidad",
    },
    unitsPerDistance: {
        en: "Units per distance",
        es: "Unidades por distancia",
    },
    unitsPerDay: {
        en: "Units per day",
        es: "Unidades por días",
    },
    parkingCountPerDay: {
        en: "Parking count per day",
        es: "Total paradas por día",
    },
    distancePerDay: {
        en: "Distance per day",
        es: "Distancia por día",
    },
    timePerUnit: {
        en: "Unit per time",
        es: "Unidad por tiempo",
    },
    unitPerPercentage: {
        en: "Unit per percentage time",
        es: "Unidad por porcentaje de tiempo",
    },
    unitPerSpeed: {
        en: "Unit per speed",
        es: "Unidad por velocidad",
    },
    unitPerMaxSpeed: {
        en: "Unit per max speed",
        es: "Unidad por velocidad maxima",
    },
    speedPerDay: {
        en: "Speed per day",
        es: "Velocidad por día",
    },
    tableTotal: {
        en: "Total {value}",
        es: "Total {value}",
    },
    deleteDisabled: {
        en: "Cannot delete this maintenance because it contain units that belong to other user ",
        es: "No puede eliminar este mantenimiento porque contiene unidades que pertenecen a otro usuario",
    },
    total: {
        en: "Total",
        es: "Total",
    },
    hidden: {
        en: "Hidden",
        es: "Oculto(s)",
    },
    blocked: {
        en: "Blocked",
        es: "Bloqueado(s)",
    },
    canceled: {
        en: "Canceled",
        es: "Cancelado(s)",
    },
    unitsStatus: {
        en: "Units' status",
        es: "Estado de unidades",
    },
    geofence: {
        en: "Geofence",
        es: "Geocerca",
    },
    transit: {
        en: "Transit",
        es: "Transito",
    },
    syncTank: {
        en: "Synchronized tanks",
        es: "Tanques sincronizados",
    },
    dualTank: {
        en: "Individual tanks",
        es: "Tanques individuales",
    },
    singleSheet: {
        en: "Single Sheet",
        es: "Una hoja",
    },
    exportToSingleSheet: {
        en: "Export in a single sheet?",
        es: "¿Exportar en una sola hoja?",
    },
    singleSheetInfo: {
        en: "All selected units will be in a single sheet instead of individual sheets for each selected unit.",
        es: "Todas las unidades seleccionadas estarán en una sola hoja en ves de una hoja por cada unidad seleccionada.",
    },
    newExportWayInfo: {
        en: "We are improving our reports! Now you can retrieve your vehicle's information and use the new export to excel button to download your data.",
        es: "Estamos mejorando nuestro reportes! Ahora puede recuperar la información de su vehículo y usar el nuevo botón Exportar a Excel para descargar sus datos.",
    },
    fuelBillTitle: {
        en: "Fuel Bills report",
        es: "Reporte de Control de Combustible",
    },
    gasStation: {
        en: "Gas Station",
        es: "Gasolinera",
    },
    requester: {
        en: "Requester",
        es: "Solicitante",
    },
    fuelValuePerDevice: {
        en: "Fuel value per unit",
        es: "Valor de combustible por dispositivo",
    },
    fuelVolumePerDevice: {
        en: "Fuel volume per unit",
        es: "Volumen de combustible por dispositivo",
    },
    visitsPerGasStation: {
        en: "Visits per Gas Station",
        es: "Visitas por gasolinera",
    },
    fuelBillPerDriver: {
        en: "Fuel Bills per staff",
        es: "Facturas de combustible por personal",
    },
    devicesByCompanyTitle: {
        en: "Devices by Company Report",
        es: "Reporte de Unidades por Compañía",
    },
    duplicated: {
        en: "Duplicated",
        es: "Duplicado(s)",
    },
    unique: {
        en: "Unique",
        es: "Unico(s)",
    },
    clickToDownload: {
        en: "Click on Download button to continue",
        es: "Has click en el botón de Descargar para continuar",
    },
    noExportForReport: {
        en: "Export is not available for this report",
        es: "Exportar no está disponible para este reporte",
    },
    speedLimit: {
        en: "Speed limit",
        es: "Limite de velocidad",
    },
    sortByViolation: {
        en: "Sort by violations",
        es: "Ordenar por faltas",
    },
    sortByName: {
        en: "Sort by name",
        es: "Ordenar por nombre",
    },
    violations: {
        en: "Violations",
        es: "Faltas",
    },
    tolerance: {
        en: "Tolerance",
        es: "Tolerancia",
    },
    inactivity: {
        en: "Inactivity",
        es: "Inactividad",
    },
    inactivityTitle: {
        en: "Inactivity report",
        es: "Reporte de Inactividad",
    },
    inactiveMoreThan: {
        en: "Inactive more than",
        es: "Inactivo más de",
    },
    inactiveTime: {
        en: "Inactive time",
        es: "Tiempo inactivo",
    },
    deliveryCycleTitle: {
        en: "Delivery Cycle report",
        es: "Reporte de Ciclos de Entrega",
    },
    ralentiTitle: {
        en: "Ralenti report",
        es: "Reporte de Ralenti",
    },
    ralentiReport: {
        en: "Ralenti",
        es: "Ralenti",
    },
    taskRoutesReport: {
        en: "Task Route",
        es: "Rutas de tareas",
    },
    taskRoutesTitle: {
        en: "Task routing report",
        es: "Reporte de Rutas de tareas",
    },
    unspecifiedOrder: {
        en: "Unspecified Order",
        es: "Orden no Especificado",
    },
    fulfilledOrder: {
        en: "Order Fulfilled",
        es: "Orden Cumplido.",
    },
    unfulfilledOrder: {
        en: "Unfulfilled Order",
        es: "Orden Incumplido",
    },
    insidePlaces: {
        en: "Inside geofences",
        es: "Dentro de geocerca",
    },
    seeInGoogleMaps: {
        en: "See on Google Maps",
        es: "Ver en GoogleMaps",
    },
    selectADevice: {
        en: "Please select a device",
        es: "Por favor seleccione una unidad",
    },
    parkings: {
        en: "Stops",
        es: "Estacionamientos",
    },
};
exports.default = translations;
